/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  useRouteError
} from 'react-router-dom';
import { BaseLayout, DetailLayout } from '@/layouts';
import PrivateRoute from './PrivateRoute';

const Dashboard = lazy(() => import('@/views/Dashboard'));
const Login = lazy(() => import('@/views/Login'));
const NotFound = lazy(() => import('@/views/NotFound'));

const PaymentList = lazy(() => import('@/views/Payment/List'));
const PaymentDetail = lazy(() => import('@/views/Payment/Detail'));

function RootErrorBoundary() {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={lazyView(<Dashboard />)} />
          <Route path=":tenantId/payment">
            <Route index element={lazyView(<PaymentList />)} />
            <Route path=":paymentId" element={<DetailLayout />}>
              <Route index element={lazyView(<PaymentDetail />)} />
            </Route>
          </Route>

          <Route path="*" element={lazyView(<NotFound />)} />
        </Route>
      </Route>
      <Route path="/login" element={lazyView(<Login />)} />
    </Route>
  )
);

export default router;
